(function($) {
    "use strict";

    const $siteHeader = $('.site-header');

	$(window).on('scroll', function(event) {
		
		if ( $(window).scrollTop() > 40 ) {

		    if(!$siteHeader.hasClass('sticky')){
                $siteHeader.addClass('sticky');
            }

		} else {
            $siteHeader.removeClass('sticky');
		}

	});

	$('.menu-toggle').on('click', function(event) {
		event.preventDefault();

        $siteHeader.toggleClass('menu-on');
	});

    const $menu = $('.main-menu');

    jQuery('.menu-item-has-children a', $menu).on('focus', function(event){

        const $a = jQuery(this);
        const $li = $a.closest('.menu-item-has-children');

        if($siteHeader.hasClass('menu-on')){

            if(!$li.hasClass('on')){

                $li.addClass('on');
                event.preventDefault();
            }

        }else{
            $li.addClass('on');
        }


    }).on('blur',function(){
        jQuery(this).closest('.menu-item-has-children').removeClass('on');
    }).on('keydown',function(e){
        // trigger click on enter and space keys on focused sub link.
        if(e.which && (e.which===13 || e.which === 32) ){
            this.click();
        }
    });

    jQuery('.menu-item-has-children > a', $menu).on('click', function(event){

        const $a = jQuery(this);
        const $li = $a.parent();

        if($siteHeader.hasClass('menu-on')){

            $li.addClass('on');

            if($li.hasClass('on') && $a.is('[aria-expanded]') ){

            }else{

                $a.attr('aria-expanded', 'true');
                event.preventDefault();
                event.stopPropagation();

                return false;
            }

        }else{
            $li.addClass('on');
        }

    });

    $('.site-header a.search-icon').on('click', function toggleSearchForm(event){

    	const $searchBlock = $(this).parent();

    	if($searchBlock.hasClass('on')){
    		$searchBlock.removeClass('on');
            $(this).focus();
		}else{
            $searchBlock.addClass('on');
            $('input', $searchBlock).focus();
		}
    	event.preventDefault();

	});

    $('.site-header .search input').on('blur', function hideSearchForm(){

        const $searchBlock = $(this).closest('.search');
        setTimeout(function(){
            if(document.activeElement && document.activeElement.classList.contains('search-icon')){
            	// do nothing as we have just clicked on toggler.
			}else{
                $searchBlock.removeClass('on');
                $('a.search-icon',$searchBlock).focus();
			}

        },1);

	}).on('focus', function (e){
        const $searchBlock = $(this).closest('.search');
        setTimeout(function(){
            if(!$searchBlock.hasClass('on')){
                $searchBlock.addClass('on');
            }

        },1);

    }).on('keydown', function(e){
            // trigger focus out and close form.
            if(e.which && (e.which===27 || e.which === 9) ){

                const $searchBlock = $(this).closest('.search');
                $searchBlock.removeClass('on');
                $('a.search-icon',$searchBlock).focus();

            }
	});

})(jQuery);